import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Pen",
  "use": "Pen-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Pen\"><path fill-rule=\"evenodd\" d=\"M43.82 14.187L18.85 40.118l-4.743-4.58L39.114 9.642l4.706 4.545zm3.107 3l5.135 4.959-25.008 25.896-5.152-4.975 25.025-25.88zm-5.73-9.703l4.863-5.035 12.948 12.503-4.862 5.036L41.198 7.484zM8 55l4.022-17.304L24.97 50.2 8 55z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol